jQuery(document).ready(function ($) {
    $('.interactive-weight-button-input').each(function (index, element) {

        const weightThreshold = parseFloat($(this).data('weightthreshold'));
        const button = $(this).next('.interactive-weight-button');
        const alterLink = button.data('alter-link');
        const alterText = button.data('alter-text');
        const originalLink = button.attr('href');
        const originalText = button.text();

        $(element).on('input', function() {
            const eingabe = parseFloat($(this).val().replace(",", "."));

            button.removeClass('disabled')

            if (!isNaN(eingabe) && eingabe > 0) {
                if (eingabe > weightThreshold) {
                    button.attr('href', alterLink); // Setzt den alternativen Link
                    button.text(alterText); // Setzt den alternativen Text
                }
                else {
                    button.attr('href', originalLink); // Setzt den ursprünglichen Link
                    button.text(originalText); // Setzt den ursprünglichen Text
                }
            }
            else {
                button.addClass('disabled')
            }

            console.log('hi')
        });
    })
});